import Navbar from "./Pages/Navbar";
import Home from "./Components/Home/Home.js";
import About from "./Components/About";
import Contact from "./Components/Contact";
import { Routes, Route } from "react-router-dom";
import Footer from "./Pages/Footer";
import "./App.css"
import ScrollToTop from "../src/Helper/Scroll.js";

function App() {
  return (
    <div className="App">
     <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
